import React, { useEffect, useRef, useState, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { CiMenuKebab } from "react-icons/ci";
import { FaRegSave } from "react-icons/fa";
import { useClickOutside } from "@mantine/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { groupType } from "../../interfaces/groups";
import { notifications } from "@mantine/notifications";
import { useAuthenticator } from "@aws-amplify/ui-react";
import LocationsTile from "../../components/locationTile/locationTile";
import { arraysEqual } from "../../utils/general";
import LocationSubTile from "../../components/locationSubTile/locationSubTile";
import AddressIcon from "../../svg/addressIcon";
import PermissionAction from "../../components/permissions/PermissionAction";
import { TbZoomQuestion } from "react-icons/tb";
import { useMediaQuery } from "@mantine/hooks";
import { FaPlus } from "react-icons/fa6";

import RestIcon from "../../svg/ResetIcon";
import {
  GridContextProvider,
  GridDropZone,
  GridItem,
  swap,
} from "react-grid-dnd";
import {
  useGetLocationsQuery,
  useEditFloorPositionsMutation,
} from "../../redux/slices/api.slice";

import { useGetFloorsQuery } from "../../hooks/hooks";
import { setBreadcrumb } from "../../redux/slices/breadCrumb.slice";
import { floorType } from "../../interfaces/groups";
import { favoritesLocsAndFloors } from "../../interfaces/bookmarks";
import { useGetFavorites } from "../../hooks/useGetFavorites";
import { useLazyGetFloorsQuery } from "../../redux/slices/api.slice";
import {
  editFloorPositions,
} from "../../redux/slices/groups.slice";
import { Button } from "@mantine/core";
import Container from "../../components/Container";
import "../../components/styles/common.css";

export interface locationsProps {}

// this site is restricted to DIL Admin only; every other role has it hidden
// from the home page site list
const DIL_ADMIN_ONLY_SITE_ID = "f74a4";

export function Locations() {
  const isScreenXl = useMediaQuery("(min-width:1280px)");
  const isScreenLg = useMediaQuery("(min-width:1024px)");
  const isScreenSm = useMediaQuery("(min-width:640px)");

  let { GrpId } = useParams();
  const [editPositions, { isLoading: isLoadingEditFloors }] =
    useEditFloorPositionsMutation();
  const id = GrpId;

  const { user } = useAuthenticator();

  const token = user.getSignInUserSession()?.getIdToken()?.payload;
  const email = token?.email;
  const userName = token?.given_name || email;

  const accountRoles = user
    .getSignInUserSession()
    ?.getAccessToken()
    ?.decodePayload()?.["cognito:groups"];
  const isDilAdmin =
    Array.isArray(accountRoles) && accountRoles.includes("DO-DILAdmin");
  const [hasPositionChanged, setHasPositionChanged] = useState(false);
  const { isLoading: isLoadingFloors } = useGetFloorsQuery(id, { skip: !id });
  const { data: groups, isLoading: isLoadingLocation } =
    useGetLocationsQuery("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [favorites, setFavorites] = useGetFavorites<favoritesLocsAndFloors>(
    "favorite-locations/floor",
    { locations: [], floors: {} }
  );
  const [floorTiles, setFloorTiles] = useState([]);
  const [selectedCat, setSelectedCat] = useState<string | null>(id ?? null);
  const { floors } = useAppSelector((state) => state.groups);

  useEffect(() => {
    setSelectedCat(id ?? null);
    setHasPositionChanged(false);
  }, [id]);



  

  useEffect(() => {
    if (id) {
      const currentLocGrp = groups?.find((l: groupType) =>
        l.id.includes(id?.slice(0, -2))
      );
      const crumbs = [
        { name: "Home", route: "/" },
        { name: currentLocGrp?.name, route: `` },
      ];
      dispatch(setBreadcrumb(crumbs));
    } else {
      dispatch(setBreadcrumb([]));
    }
  }, [dispatch, groups, id]);
  const originalFloorPosition = useRef(null);

  useEffect(() => {
    if (selectedCat !== null && floors) {
      const f = floors
        .filter((floor) => floor.locationID === id)
        .sort((a, b) => a.position - b.position);
      setFloorTiles(f);
      originalFloorPosition.current = f;
    }
  }, [selectedCat, floors, favorites]);

  const loc = useMemo(() => {
    return groups?.find((group) => group.id === id);
  }, [groups, id]);

  // hide the DIL-Admin-only site from every other role's home page
  const visibleGroups = useMemo(
    () =>
      groups?.filter(
        (group) => isDilAdmin || group.id !== DIL_ADMIN_ONLY_SITE_ID,
      ),
    [groups, isDilAdmin],
  );

  const updateFloorPositions = async () => {
    const floorPositions = floorTiles.reduce((acc, el, index) => {
      acc[el.id] = index;
      return acc;
    }, {});

    const result = await editPositions({
      locationID: GrpId,
      content: floorPositions,
    });

    try {
      //@ts-ignore
      if (result.data) {
        dispatch(editFloorPositions({ positions: floorPositions }));
        notifications.show({
          title: "Success",
          message: "Floor position edited successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (error) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
    setHasPositionChanged(false);
  };

  function handleChange(sourceId, sourceIndex, targetIndex, targetId) {
    const nextState = swap(floorTiles, sourceIndex, targetIndex);

    if (!arraysEqual(floorTiles, nextState)) {
      setFloorTiles(nextState);
      setHasPositionChanged(true);
    }
  }

  useEffect(() => {
    if (hasPositionChanged) {
      updateFloorPositions();
    }
  }, [hasPositionChanged]);

  const floorCradsPerRow = isScreenXl ? 4 : isScreenLg ? 3 : isScreenSm ? 2 : 1;

 
  return (
    <Container>
      <div>
        {selectedCat ? (
          isLoadingFloors ? (
            <FloorsLoader />
          ) : (
            <div className=" flex flex-col  gap-5">
              <div className="flex sm:flex-row flex-col  justify-between sm:items-center">
                <div className=" flex  items-center  gap-5 mb-5 md:mb-0">
                  <div className="w-24 h-24">
                    {loc?.imageURL ? (
                      <img
                        src={loc?.imageURL}
                        alt="locationImage"
                        className="w-full h-full rounded-[50%]"
                      />
                    ) : (
                      <div className="w-full rounded-[50%]  bg-lightGray  h-full  flex items-center justify-center">
                        <AddressIcon width="40px" height="40px" />
                      </div>
                    )}
                  </div>
                  <div>
                    <h2 className="font-mg text-4xl py-2">{loc?.name}</h2>
                    <p className="text-grayText2 text-lg ">
                      {loc?.description ||
                        `Explore and discover available desks across multiple
                      locations.`}
                    </p>
                  </div>
                </div>
                <PermissionAction operation="C" resource="floors">
                  <div className="flex  gap-2 items-center relative mt-3 sm:mt-0 justify-end">
                    <Button
                      color={"#FB6514"}
                      radius="xl"
                      size="md"
                      onClick={() => {
                        navigate(`/newFloor/${selectedCat}`);
                      }}
                      leftSection={<FaPlus />}
                      data-cy="createFloor"
                    >
                      Create New Floor
                    </Button>
                  </div>
                </PermissionAction>
              </div>
              {floorTiles.length > 0 ? (
                <div className="w-full flex gap-6 flex-col ">
                  <GridContextProvider onChange={handleChange}>
                    <GridDropZone
                      id="floorTiles"
                      boxesPerRow={floorCradsPerRow}
                      rowHeight={360}
                      style={{
                        height:
                          360 * Math.ceil(floorTiles.length / floorCradsPerRow),
                      }}
                    >
                      {floorTiles.map((item) => (
                        <GridItem key={item.id} className="p-2 cursor-grab">
                          <LocationSubTile
                            floor={item}
                            favorites={favorites}
                            setFavorites={setFavorites}
                          />
                        </GridItem>
                      ))}
                    </GridDropZone>
                  </GridContextProvider>
                </div>
              ) : (
                <NoResource type="floors" />
              )}
            </div>
          )
        ) : isLoadingLocation ? (
          <LocationsLoader />
        ) : (
          <div className=" w-full pt-10">
            <div className=" flex flex-col mx-auto gap-1  ">
              <div className="flex justify-between flex-col sm:flex-row  sm:items-center">
                <h2 className="text-black text-4xl mb-5 ">
                  Hello, {userName} !
                </h2>
                <p className=" text-xl  text-grayText2 my-0 block sm:hidden mb-5 sm:mb-0">
                  Explore and discover available Sites & Desks across multiple
                  locations.
                </p>
                <PermissionAction operation="C" resource="locations">
                  <div className="flex gap-4 items-center">
                    <Button
                      color={"#FB6514"}
                      radius="md"
                      size="md"
                      onClick={() => {
                        navigate("/newSpace");
                      }}
                      leftSection={<FaPlus />}
                    >
                      Create New Site
                    </Button>
                  </div>
                </PermissionAction>
              </div>
              <p className=" text-xl  text-grayText2 my-0 hidden sm:block">
                Explore and discover available Sites & Desks across multiple
                locations.
              </p>
              {visibleGroups?.length > 0 ? (
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3   gap-10 mt-14 xl:grid-cols-4 ">
                  {visibleGroups?.map((group) => {
                    return (
                      <LocationsTile
                        setSelectedCat={() => {
                          setSelectedCat(group.id);
                          navigate(`/Location/${group.id}`);
                        }}
                        group={group}
                        key={group.name}
                        favorites={favorites}
                        setFavorites={setFavorites}
                      />
                    );
                  })}
                </div>
              ) : (
                <NoResource type="sites" />
              )}
            </div>
          </div>
        )}
      </div>
    </Container>
  );
}

export default Locations;

const LocationsLoader = () => {
  return (
    <div className=" w-full pt-10">
      <div className=" flex flex-col mx-auto gap-1  ">
        <div className="flex justify-between flex-col sm:flex-row  sm:items-center">
          <div className=" mb-5 w-[200px] h-[50px] bg-[#8896ab] rounded-3xl loader" />
          <p className="  my-0 block sm:hidden mb-5 sm:mb-0 w-full  h-[50px] rounded-3xl  bg-[#8896ab] loader" />

          <div className="rounded-[100px] w-[250px] h-[50px] bg-[#8896ab] loader" />
        </div>
        <p className="  my-0 hidden sm:block w-[60%] h-[50px] bg-[#8896ab] loader rounded-3xl " />
        <div className=" w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3   gap-10 mt-14 xl:grid-cols-4 ">
          {Array.from({ length: 8 }, (_, index) => {
            return (
              <div
                className="loader rounded-3xl w-full min-h-[500px]  bg-[#8896ab]"
                key={index + 1}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

const FloorsLoader = () => {
  return (
    <div className=" flex flex-col  gap-5">
      <div className=" flex sm:flex-row flex-col  justify-between sm:items-center items-center">
        <div className="flex items-center w-full gap-2">
          <div className="rounded-[50%] w-[100px] h-[100px]  bg-[#8896ab]  flex items-center justify-center loader" />
          <div className="w-full h-fit">
            <div className=" w-[60%] sm:w-[30%] bg-[#8896ab]  h-[40px] rounded-3xl loader" />
            <p className=" w-full sm:w-[50%]   bg-[#8896ab]  h-[40px] rounded-3xl loader mt-2" />
          </div>
        </div>
        <div className="rounded-[100px] w-full mt-5 sm:mt-0 sm:w-[250px] h-[50px] bg-[#8896ab] loader" />
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  xl:grid-cols-4 gap-5 mt-10 ">
        {Array.from({ length: 8 }, (_, index) => {
          return (
            <div
              className="loader rounded-3xl w-full min-h-[350px]  bg-[#8896ab]"
              key={index + 1}
            />
          );
        })}
      </div>
    </div>
  );
};

const NoResource = ({ type }) => {
  return (
    <div className="w-full capitalize h-[400px] mt-10 rounded-[20px] border border-solid border-grayText4   text-2xl flex items-center justify-center">
      <div className="flex items-center justify-center flex-col gap-2 ">
        <TbZoomQuestion size={60} />
        <div className="text-center ">
          <p className="text-2xl font-semibold"> {` No ${type}`}</p>
          <p className="text-sm sm:text-base text-grayText3   max-w-[500px] text-center">
            {`Get started by creating your ${type} now!`}
          </p>
        </div>
      </div>
    </div>
  );
};
